import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
  const { pathname } = useLocation();
  const urlPaths = pathname.split("/");
  urlPaths[0] === "" && urlPaths?.shift();

  return (
    <nav className="flex text-white text-sm mb-6" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        <li className="inline-flex items-center">
          <Link to="/" className="inline-flex items-center hover:underline">
            <svg
              className="w-4 h-4 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 2L2 8h2v8h4v-4h4v4h4V8h2L10 2z" />
            </svg>
            Home
          </Link>
        </li>
        {urlPaths.map((path, index) => (
          <li key={index}>
            <div className="flex items-center">
              <svg
                className="w-4 h-4 text-white mx-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M7.05 4.05a.5.5 0 01.7 0L13 9.293l-5.24 5.243a.5.5 0 11-.707-.707L11.586 9 7.05 4.464a.5.5 0 010-.707z" />
              </svg>

              {urlPaths.length !== index + 1 ? (
                <Link
                  to={`/${path}`}
                  className="ml-1 hover:underline capitalize"
                >
                  {path}
                </Link>
              ) : (
                <span className="ml-1 hover:underline capitalize">{path}</span>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
